// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZqYc2dR{display:inline-flex;align-items:center;gap:.5em}@media(max-width: 899px){.ZqYc2dR{gap:.25em}}.g3Su3iu{display:inline-flex;max-width:260px;text-align:center}@media(max-width: 899px){.g3Su3iu{max-width:242px}}.le1iUOa{display:inline-flex;margin:-0.5em 0 -0.5em -0.5em;padding:.5em}@media(max-width: 899px){.le1iUOa{margin:-0.5em -0.25em -0.5em -0.5em}}.kd3WgpQ{width:1em;height:1em;font-size:16px}@media(max-width: 899px){.kd3WgpQ{width:1em;height:1em}}.zjIOljk,.ZqYc2dR .zjIOljk{font-size:14px;line-height:1.5;line-height:21px}@media(max-width: 899px){.zjIOljk,.ZqYc2dR .zjIOljk{font-size:12px;line-height:15px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ZqYc2dR`,
	"tooltip": `g3Su3iu`,
	"container": `le1iUOa`,
	"icon": `kd3WgpQ`,
	"text": `zjIOljk`
};
export default ___CSS_LOADER_EXPORT___;
